import { render } from "./Judge.vue?vue&type=template&id=760dc1f8"
import script from "./Judge.vue?vue&type=script&lang=js"
export * from "./Judge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__